module.exports = __webpack_public_path__ + "img/nfc-slash.25591f05.svg";